import { render, staticRenderFns } from "./capitalExpenditure.vue?vue&type=template&id=b5edf7b8&scoped=true"
import script from "./capitalExpenditure.vue?vue&type=script&lang=js"
export * from "./capitalExpenditure.vue?vue&type=script&lang=js"
import style0 from "./capitalExpenditure.vue?vue&type=style&index=0&id=b5edf7b8&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5edf7b8",
  null
  
)

export default component.exports